import{startOfWeek as t}from"./startOfWeek.js";function e(e){return t(e,{weekStartsOn:1})}export{e as default,e as startOfISOWeek};
//# sourceMappingURL=startOfISOWeek.js.map
